module.exports = __webpack_public_path__ + "img/join_img4.9cbaf882.jpg";